module.exports = __webpack_public_path__ + "img/14-add-new-profile.6139e044.svg";